import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import ArrowStatus from "./Components/ArrowStatus";
import { StyledTableCell, StyledTableRow, useStyles } from "./styles";
import OpponentName from "./Components/OpponentName";
import CellColorTypography from "./Components/CellColorTypography";
import { useState } from "react";
import { useSelector } from "react-redux";
import { apiPost } from "../../utils/apiRequests";
import { useLocation, useParams } from "react-router-dom";
import { useEffect } from "react";
import ApiEndpoints from "../../utils/ApiEndpoints";

// component
const SideBoxItem = ({ value }) => {
  return (
    <Typography variant="body2" my={1.3} color="initial" fontWeight="bold">
      {value}
    </Typography>
  );
};

const ScoreboardTable = ({ members }) => {
  const classes = useStyles();
  const { id } = useParams();
  const { state } = useLocation();

  // Redux

  // State
  const [scores, setScores] = useState([]);
  const [defaultTeesAndGroup, setDefaultTeesAndGroup] = useState([]);
  // const [refresh, setRefresh] = useState(false);
  const [playersInOutScore, setPlayersInOutScore] = useState({
    player1In: 0,
    player1Out: 0,
    player2In: 0,
    player2Out: 0,
    player3In: 0,
    player3Out: 0,
    player4In: 0,
    player4Out: 0,
  });

  useEffect(() => {
    let body = {
      match_id: id,
      round_id: state._id,
    };

    apiPost("/api/league/getmatchscores", body, (res) => {
      if (res.roundMatchData.length === 0) {
        return true;
      } else {
        setScores(res.roundMatchData);

        for (let i = 0; i < 2; i++) {
          if (i === 0) {
            let temp1In = 0;
            let temp1Out = 0;
            let temp2In = 0;
            let temp2Out = 0;
            res.roundMatchData[0].matches.group1[0].mp_score.reduce(
              (total, num, index) => {
                if (index < 9) {
                  temp1In += num.score;
                } else {
                  temp1Out += num.score;
                }
              },
              0
            );

            res.roundMatchData[0].matches.group1[1].mp_score.reduce(
              (total, num, index) => {
                if (index < 9) {
                  temp2In += num.score;
                } else {
                  temp2Out += num.score;
                }
              },
              0
            );

            setPlayersInOutScore((pre) => {
              return {
                ...pre,
                player1In: temp1In,
                player1Out: temp1Out,
                player2In: temp2In,
                player2Out: temp2Out,
              };
            });
          } else {
            let temp1In = 0;
            let temp1Out = 0;
            let temp2In = 0;
            let temp2Out = 0;
            res.roundMatchData[0].matches.group2[0].mp_score.reduce(
              (total, num, index) => {
                if (index < 9) {
                  temp1In += num.score;
                } else {
                  temp1Out += num.score;
                }
              },
              0
            );

            res.roundMatchData[0].matches.group2[1].mp_score.reduce(
              (total, num, index) => {
                if (index < 9) {
                  temp2In += num.score;
                } else {
                  temp2Out += num.score;
                }
              },
              0
            );

            setPlayersInOutScore((pre) => {
              return {
                ...pre,
                player3In: temp1In,
                player3Out: temp1Out,
                player4In: temp2In,
                player4Out: temp2Out,
              };
            });
          }
        }
      }
    });

    return () => {
      setScores([]);
    };
  }, []);

  useEffect(() => {
    let body2 = {
      match_id: id,
      league_id: state.league_id,
    };

    apiPost(`${ApiEndpoints.dmpgroupandtees.base}`, body2, (res) => {
      let grpData = res.groupsData1;

      let tempArr = [];

      for (let i = 0; i < grpData.length; i++) {
        let filterDefTee = grpData[i].tees.user_tee.filter(
          (val) => val.is_default === true
        );

        let tempObj = {
          name: grpData[i].name,
          handicap: filterDefTee[0].handicap_value,
          tee: filterDefTee[0].tee_color,
        };

        tempArr.push(tempObj);
      }

      setDefaultTeesAndGroup(tempArr);
    });
  }, []);

  return (
    <TableContainer sx={{ padding: 5 }}>
      <Table>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell sx={{ width: "200px" }} rowSpan={3}>
              <Box>
                {scores.length > 0 ? (
                  <SideBoxItem
                    value={
                      scores[0].course_name !== ""
                        ? scores[0].course_name
                        : "Select Course"
                    }
                  />
                ) : (
                  <SideBoxItem value="Select Course" />
                )}

                {scores.length > 0 ? (
                  <SideBoxItem
                    value={
                      scores[0].matches.date !== ""
                        ? scores[0].matches.date
                        : "Date"
                    }
                  />
                ) : (
                  <SideBoxItem value="Date" />
                )}

                {scores.length > 0 ? (
                  <SideBoxItem
                    value={
                      scores[0].matches.time !== ""
                        ? scores[0].matches.time
                        : "Time"
                    }
                  />
                ) : (
                  <SideBoxItem value="Time" />
                )}
              </Box>
            </StyledTableCell>
            <StyledTableCell sx={{ fontWeight: 700 }} align="center">
              HOLES
            </StyledTableCell>
            {Array.apply(null, Array(18)).map((v, i) =>
              i === 9 ? (
                <>
                  <StyledTableCell align="center" sx={{ fontWeight: 700 }}>
                    OUT
                  </StyledTableCell>
                  <StyledTableCell align="center">{i + 1}</StyledTableCell>
                </>
              ) : (
                <StyledTableCell align="center">{i + 1}</StyledTableCell>
              )
            )}
            <StyledTableCell sx={{ fontWeight: 700 }} align="center">
              IN
            </StyledTableCell>
            <StyledTableCell sx={{ fontWeight: 700 }} align="center">
              TOTAL
            </StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell sx={{ fontWeight: 700 }} align="center">
              INDEX
            </StyledTableCell>
            {Array.apply(null, Array(18)).map((v, i) =>
              i === 9 ? (
                <>
                  <StyledTableCell
                    align="center"
                    sx={{ fontWeight: 700 }}
                  ></StyledTableCell>
                  <StyledTableCell align="center">
                    {scores.length > 0
                      ? scores[0].matches?.group1[0].mp_score[i]?.index
                      : "0"}
                  </StyledTableCell>
                </>
              ) : (
                <StyledTableCell align="center">
                  {scores.length > 0
                    ? scores[0].matches?.group1[0].mp_score[i]?.index
                    : "0"}
                </StyledTableCell>
              )
            )}
            <StyledTableCell align="center"></StyledTableCell>
            <StyledTableCell align="center"></StyledTableCell>
          </StyledTableRow>
          <StyledTableRow>
            <StyledTableCell sx={{ fontWeight: 700 }} align="center">
              PAR
            </StyledTableCell>
            {Array.apply(null, Array(18)).map((v, i) =>
              i === 9 ? (
                <>
                  <StyledTableCell align="center">
                    {scores.length > 0 ? "36" : "0"}
                  </StyledTableCell>
                  <StyledTableCell align="center">
                    {scores.length > 0
                      ? scores[0].matches?.group1[0].mp_score[i]?.par
                      : "0"}
                  </StyledTableCell>
                </>
              ) : (
                <StyledTableCell align="center">
                  {scores.length > 0
                    ? scores[0].matches?.group1[0].mp_score[i]?.par
                    : "0"}
                </StyledTableCell>
              )
            )}

            <StyledTableCell align="center">
              {scores.length > 0 ? "36" : "0"}
            </StyledTableCell>
            <StyledTableCell align="center">
              {scores.length > 0 ? "72" : "0"}
            </StyledTableCell>
          </StyledTableRow>

          {/* Group 1  */}
          {[0, 0].map((v, i) => {
            let bgColor = "#C4C4C4";

            if (scores.length > 0) {
              if (scores[0]?.matches?.group1[i].tee === "yellow") {
                bgColor = "#FFC700";
              } else if (scores[0]?.matches?.group1[i].tee === "blue") {
                bgColor = "#0000FF";
              } else if (scores[0]?.matches?.group1[i].tee === "black") {
                bgColor = "#000000";
              }
            } else {
              if (defaultTeesAndGroup.length > 0) {
                if (defaultTeesAndGroup[i].tee === "yellow") {
                  bgColor = "#FFC700";
                } else if (defaultTeesAndGroup[i].tee === "blue") {
                  bgColor = "#0000FF";
                } else if (defaultTeesAndGroup[i].tee === "black") {
                  bgColor = "#000000";
                }
              }
            }

            return (
              <StyledTableRow key={i}>
                <StyledTableCell align="center">
                  <OpponentName
                    value={defaultTeesAndGroup[i]?.name}
                    color="#0000FF"
                  />
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Box
                    className={classes.textBox}
                    sx={{ backgroundColor: bgColor }}
                  >
                    <Box className={classes.numberBox}>
                      {scores.length > 0
                        ? scores[0]?.matches?.group1[i].playing_handicap
                        : defaultTeesAndGroup.length > 0 &&
                          defaultTeesAndGroup[i].handicap}
                    </Box>
                    <Typography
                      variant="body1"
                      className={classes.textBoxChild}
                    >
                      {scores.length > 0
                        ? scores[0]?.matches?.group1[i].tee
                        : defaultTeesAndGroup.length > 0 &&
                          defaultTeesAndGroup[i].tee}
                    </Typography>
                  </Box>
                </StyledTableCell>

                {Array.apply(null, Array(18)).map((v, ind) =>
                  ind === 9 ? (
                    <>
                      <StyledTableCell align="center">
                        {i === 0
                          ? playersInOutScore.player1In
                          : playersInOutScore.player2In}
                      </StyledTableCell>

                      {scores.length > 0 ? (
                        <StyledTableCell align="center" sx={{ padding: "5px" }}>
                          {scores[0].matches.group1[i].mp_score.length > 0 ? (
                            <>
                              {scores[0].matches.group1[i].mp_score[ind]
                                .score !== null ? (
                                <CellColorTypography
                                  data={
                                    scores[0]?.matches?.group1[i]?.mp_score[ind]
                                  }
                                />
                              ) : (
                                "0"
                              )}
                            </>
                          ) : (
                            "0"
                          )}
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell align="center">0</StyledTableCell>
                      )}
                    </>
                  ) : (
                    <>
                      {scores.length > 0 ? (
                        <StyledTableCell align="center" sx={{ padding: "5px" }}>
                          {scores[0].matches.group1[i].mp_score.length > 0 ? (
                            <>
                              {scores[0].matches.group1[i].mp_score[ind]
                                .score !== null ? (
                                <CellColorTypography
                                  data={
                                    scores[0]?.matches?.group1[i]?.mp_score[ind]
                                  }
                                />
                              ) : (
                                "0"
                              )}
                            </>
                          ) : (
                            "0"
                          )}
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell align="center">0</StyledTableCell>
                      )}
                    </>
                  )
                )}
                <StyledTableCell align="center">
                  {i === 0
                    ? playersInOutScore.player1Out
                    : playersInOutScore.player2Out}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {scores.length > 0
                    ? scores[0]?.matches.group1[i].gross_score
                    : "0"}
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
          {/* Vs  */}
          <StyledTableRow>
            <StyledTableCell align="center">
              <OpponentName value="vs" color="#000" />
            </StyledTableCell>
            <StyledTableCell align="center"></StyledTableCell>
            {Array.apply(null, Array(18)).map((v, i) =>
              i === 9 ? (
                <>
                  <StyledTableCell align="center"></StyledTableCell>
                  <StyledTableCell align="center">
                    {scores.length > 0 ? (
                      <>
                        {scores[0].matches.match_status_track[i] ? (
                          <ArrowStatus
                            value={
                              scores[0].matches.match_status_track[i]?.count
                            }
                            color={
                              scores[0].matches.match_status_track[i]?.label ===
                              "group1"
                                ? "#0000FF"
                                : "#FF0000"
                            }
                          />
                        ) : (
                          "-"
                        )}
                      </>
                    ) : (
                      "-"
                    )}
                  </StyledTableCell>
                </>
              ) : (
                <StyledTableCell align="center">
                  {scores.length > 0 ? (
                    <>
                      {scores[0].matches.match_status_track ? (
                        <>
                          {scores[0].matches.match_status_track[i] ? (
                            <ArrowStatus
                              value={
                                scores[0].matches.match_status_track[i]?.count
                              }
                              color={
                                scores[0].matches.match_status_track[i]
                                  ?.label === "group1"
                                  ? "#0000FF"
                                  : "#FF0000"
                              }
                            />
                          ) : (
                            "-"
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </>
                  ) : (
                    "-"
                  )}
                </StyledTableCell>
              )
            )}
            <StyledTableCell align="center" colSpan={2}>
              {scores[0]?.matches?.sudden_death && (
                <p
                  style={{
                    marginBottom: 0,
                    color:
                      scores[0]?.matches?.won === "group1"
                        ? "#0000FF"
                        : "#FF0000",
                  }}
                >
                  Won In Play Off
                </p>
              )}
            </StyledTableCell>
          </StyledTableRow>
          {/* Group 2 */}
          {[0, 0].map((v, i) => {
            let bgColor = "#C4C4C4";

            if (scores.length > 0) {
              if (scores[0]?.matches?.group2[i].tee === "yellow") {
                bgColor = "#FFC700";
              } else if (scores[0]?.matches?.group2[i].tee === "blue") {
                bgColor = "#0000FF";
              } else if (scores[0]?.matches?.group2[i].tee === "black") {
                bgColor = "#000000";
              }
            } else {
              if (defaultTeesAndGroup.length > 0) {
                if (defaultTeesAndGroup[i + 2].tee === "yellow") {
                  bgColor = "#FFC700";
                } else if (defaultTeesAndGroup[i + 2].tee === "blue") {
                  bgColor = "#0000FF";
                } else if (defaultTeesAndGroup[i + 2].tee === "black") {
                  bgColor = "#000000";
                }
              }
            }

            return (
              <StyledTableRow key={i}>
                <StyledTableCell align="center">
                  <OpponentName
                    value={defaultTeesAndGroup[i + 2]?.name}
                    color="#FF0000"
                  />
                </StyledTableCell>
                <StyledTableCell align="center">
                  <Box
                    className={classes.textBox}
                    sx={{
                      backgroundColor: bgColor,
                    }}
                  >
                    <Box className={classes.numberBox}>
                      {scores.length > 0
                        ? scores[0]?.matches?.group2[i].playing_handicap
                        : defaultTeesAndGroup.length > 0 &&
                          defaultTeesAndGroup[i + 2].handicap}
                    </Box>
                    <Typography
                      variant="body1"
                      className={classes.textBoxChild}
                    >
                      {scores.length > 0
                        ? scores[0]?.matches?.group2[i].tee
                        : defaultTeesAndGroup.length > 0 &&
                          defaultTeesAndGroup[i + 2].tee}
                    </Typography>
                  </Box>
                </StyledTableCell>

                {Array.apply(null, Array(18)).map((v, ind) =>
                  ind === 9 ? (
                    <>
                      <StyledTableCell align="center">
                        {i === 0
                          ? playersInOutScore.player3In
                          : playersInOutScore.player3In}
                      </StyledTableCell>
                      {scores.length > 0 ? (
                        <StyledTableCell align="center" sx={{ padding: "5px" }}>
                          {scores[0].matches.group2[i].mp_score.length > 0 ? (
                            <>
                              {scores[0].matches.group2[i].mp_score[ind]
                                .score !== null ? (
                                <CellColorTypography
                                  data={
                                    scores[0]?.matches?.group2[i]?.mp_score[ind]
                                  }
                                />
                              ) : (
                                "0"
                              )}
                            </>
                          ) : (
                            "0"
                          )}
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell align="center">0</StyledTableCell>
                      )}
                    </>
                  ) : (
                    <>
                      {scores.length > 0 ? (
                        <StyledTableCell align="center" sx={{ padding: "5px" }}>
                          {scores[0].matches.group2[i].mp_score.length > 0 ? (
                            <>
                              {scores[0].matches.group2[i].mp_score[ind]
                                .score !== null ? (
                                <CellColorTypography
                                  data={
                                    scores[0]?.matches?.group2[i]?.mp_score[ind]
                                  }
                                />
                              ) : (
                                "0"
                              )}
                            </>
                          ) : (
                            "0"
                          )}
                        </StyledTableCell>
                      ) : (
                        <StyledTableCell align="center">0</StyledTableCell>
                      )}
                    </>
                  )
                )}
                <StyledTableCell align="center">
                  {i === 0
                    ? playersInOutScore.player3Out
                    : playersInOutScore.player4Out}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {scores.length > 0
                    ? scores[0]?.matches.group2[i]?.gross_score
                    : "0"}
                </StyledTableCell>
              </StyledTableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ScoreboardTable;
